import { createApp } from "vue";
import { createHead } from "@vueuse/head";
import App from "./App.vue";
import { createWebHistory, createRouter } from "vue-router";
import HomePages from "@/components/HomePages.vue";
import ProjectPages from "@/components/pages/ProjectPages.vue";
import BlogPages from "@/components/pages/BlogPages.vue";
import LogisticsShkureno from "@/components/project/LogisticsShkureno.vue";
import YourYogaCare from "@/components/project/YourYogaCare.vue";
import AladariPages from "@/components/project/AladariPages.vue";
import SevenStar from "@/components/project/SevenStar.vue";
import OneginCottages from "@/components/project/OneginCottages.vue";
import VatamanyukPartners from "@/components/project/VatamanyukPartners.vue";
import ServicesPages from "@/components/pages/ServicesPages.vue";
import SiteServices from "@/components/services/SiteServices.vue";
import DesignCorporateIdentity from "@/components/services/DesignCorporateIdentity.vue";
import ComprehensiveAnalytics from "@/components/services/ComprehensiveAnalytics.vue";
import SEOOptimizationPromotion from "@/components/services/SEOOptimizationPromotion.vue";
import TechnicalSupportService from "@/components/services/TechnicalSupportService.vue";
import ContactsPages from "@/components/pages/ContactsPages.vue";
import ArticlePage from "@/components/ArticlePage.vue";
import AdminPage from "@/components/AdminPage.vue";

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { name: "HomePages", path: "/", component: HomePages },
    { name: "ProjectPages", path: "/all_project", component: ProjectPages },
    { name: "BlogPages", path: "/blog", component: BlogPages },
    { name: "LogisticsShkurenko", path: "/LogisticsShkurenko", component: LogisticsShkureno },
    { path: "/LogisticsShkureno", redirect: "/LogisticsShkurenko" },
    { name: "YourYogaCare", path: "/YourYogaCare", component: YourYogaCare },
    { name: "AladariPages", path: "/AladariPages", component: AladariPages },
    { name: "SevenStar", path: "/SevenStar", component: SevenStar },
    { name: "OneginCottages", path: "/OneginCottages", component: OneginCottages },
    { name: "VatamanyukPartners", path: "/VatamanyukPartners", component: VatamanyukPartners },
    { name: "ServicesPages", path: "/services", component: ServicesPages },
    { name: "ContactsPages", path: "/contacts", component: ContactsPages },
    { name: "SiteServices", path: "/site_and_services", component: SiteServices },
    { name: "DesignCorporateIdentity", path: "/Design_and_Corporate_Identity", component: DesignCorporateIdentity },
    { name: "ComprehensiveAnalytics", path: "/Comprehensive_Analytics", component: ComprehensiveAnalytics },
    { name: "SEOOptimizationPromotion", path: "/SEO_Optimization_Promotion", component: SEOOptimizationPromotion },
    { name: "TechnicalSupportService", path: "/Technical_Support_Service", component: TechnicalSupportService },
    { name: "AdminPage", path: "/admin", component: AdminPage },
    { path: "/:slug", component: ArticlePage },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

const app = createApp(App);
const head = createHead();
app.use(router);
app.use(head);
app.mount("#app");
